// Sleepify Starter Theme by Sleepless Media
//
// Main Javascript entry file.
console.log('This site was developed by https://www.sleeplessmedia.com');

(function ($) {
	$(window).ready(function () {
		// Globals
		document.body.addEventListener('mousedown', function () {
			document.body.classList.add('using-mouse');
		});
		document.body.addEventListener('keydown', function () {
			document.body.classList.remove('using-mouse');
		});
		function setPromoBannerHeightVar() {
			var $promoBanner = $('.promo-banner');
			if ($promoBanner.length && $promoBanner.is(':visible')) {
				document.documentElement.style.setProperty(
					'--promo-banner-height',
					''.concat($promoBanner.outerHeight(), 'px')
				);
			}
		}
		setPromoBannerHeightVar();
		$(window).on('load resize', setPromoBannerHeightVar);
		$(window).on('scroll load', function (event) {
			if ($(document).scrollTop() > 0) {
				$('body').addClass('scrolled');
			} else {
				$('body').removeClass('scrolled');
			}
		}); // Knockout Stuff

		var ViewModel = function ViewModel() {
			var self = this; //ReCharge

			this.recharge_ed_duration = ko.observable();
			this.recharge_onetime = ko.observable();
			this.recharge_autodeliver = ko.observable(); // Cookies By The Dozen Page

			this.dozen_line_items = ko.observableArray([0]);
			this.dozen_featured_image = ko.observable('');
			this.dozen_total = ko.observable(0);
			this.dozen_compare_at_total = ko.observable(0);
			this.dozen_line_items = ko.observableArray([]);
			this.dozen_quantity = ko.observable(0);
			this.dozen_prod_obj = ko.observable({});

			this.toDollars = function (num) {
				return '$' + (parseInt(num) / 100).toFixed(2);
			};

			this.dozen_line_item_properties = ko.computed(function () {
				var newArr = self.dozen_line_items().map(function (element) {
					return ''
						.concat(element['title'], ' (')
						.concat(element['quantity'], ')');
				});
				return newArr;
			});
			this.dozen_has_3_dozen = ko.computed(function () {
				if (self.dozen_line_items().length > 0) {
					var count = self.dozen_line_items().reduce(function (
						acc,
						element
					) {
						return acc + parseInt(element.quantity);
					}, 0);
					return count >= 3;
				}
			});

			this.dozen_select_change = function () {
				var updated_line_items = [];
				var updated_total = 0;
				$('.dozen-select').each(function (index) {
					if ($(this).val() != '0') {
						updated_line_items.push({
							title: $(this)
								.closest('.end')
								.prev()
								.find('.title')
								.html()
								.trim(),
							quantity: $(this).val(),
						});
						updated_total = updated_total + parseInt($(this).val());
					}
				});
				self.dozen_quantity(updated_total);
				self.dozen_total(
					updated_total * self.dozen_prod_obj()['price']
				);
				self.dozen_compare_at_total(
					updated_total * self.dozen_prod_obj()['compare-at-price']
				);
				self.dozen_line_items(updated_line_items);
			};

			this.dozen_swap_featured_image = function (data, event) {
				var val = $(event.target).attr('src');
				$(event.target).closest('li').siblings().removeClass('active');
				$(event.target).closest('li').addClass('active');
				self.dozen_featured_image(val);
			};

			this.dozen_add_to_cart = function (data, event) {
				var goodToGo = true;
				var items = CartJS.cart.items;
				var current = self.dozen_line_item_properties();
				var currentObj = Object.assign({}, current);
				var stopIndex = 0;

				if (items.length === 0) {
					CartJS.addItem(
						self.dozen_prod_obj()['id'],
						self.dozen_quantity(),
						self.dozen_line_item_properties(),
						{
							success: function success(data, textStatus, jqXHR) {
								var myToast = Toastify({
									text: 'Your selections have been added to the cart.',
									duration: 6000,
									gravity: 'top',
									stopOnFocus: true,
									onClick: function onClick() {
										window.location.href = '/cart';
									},
								});
								myToast.showToast();
							},
							error: function error(
								jqXHR,
								textStatus,
								errorThrown
							) {
								var myToast = Toastify({
									duration: 10000,
									gravity: 'top',
									className: 'product-add-error',
									text: 'There was a problem adding this item to the cart. :(',
								});
								myToast.showToast();
							},
						}
					);
				} else {
					for (i = 0; i < items.length; i++) {
						var properties = items[i].properties;

						var propString = JSON.stringify(properties);
						var currentString = JSON.stringify(currentObj);
						propString = propString.replace(/ *\([^)]*\) */g, '');
						currentString = currentString.replace(
							/ *\([^)]*\) */g,
							''
						);

						if (propString === currentString) {
							goodToGo = false;
							stopIndex = i;
						}

						if (i == items.length - 1) {
							if (goodToGo == true) {
								CartJS.addItem(
									self.dozen_prod_obj()['id'],
									self.dozen_quantity(),
									self.dozen_line_item_properties(),
									{
										success: function success(
											data,
											textStatus,
											jqXHR
										) {
											var myToast = Toastify({
												text: 'Your selections have been added to the cart.',
												duration: 6000,
												gravity: 'top',
												stopOnFocus: true,
												onClick: function onClick() {
													window.location.href =
														'/cart';
												},
											});
											myToast.showToast();
										},
										error: function error(
											jqXHR,
											textStatus,
											errorThrown
										) {
											var myToast = Toastify({
												duration: 10000,
												gravity: 'top',
												className: 'product-add-error',
												text: 'There was a problem adding this item to the cart. :(',
											});
											myToast.showToast();
										},
									}
								);
							} else {
								var oldQuant =
									CartJS.cart.items[stopIndex].quantity;
								var newQuant = oldQuant + self.dozen_quantity();
								var existingProp =
									CartJS.cart.items[stopIndex].properties;
								var existingPropArray =
									Object.values(existingProp);
								var addProp = self.dozen_line_item_properties();

								var newArray = [];

								for (i = 0; i < existingPropArray.length; i++) {
									var existingString = existingPropArray[i];
									var addString = addProp[i];

									var existingStringSplit =
										existingString.split(' (');
									var existingStringSplitValue =
										existingStringSplit[1].substring(
											0,
											existingStringSplit[1].length - 1
										);

									var addStringSplit = addString.split(' (');
									var addStringSplitValue =
										addStringSplit[1].substring(
											0,
											addStringSplit[1].length - 1
										);

									var newNum =
										existingStringSplitValue * 1 +
										addStringSplitValue * 1;

									var newString =
										addStringSplit[0] + ' (' + newNum + ')';
									newArray.push(newString);
								}

								CartJS.updateItem(
									stopIndex + 1,
									newQuant,
									newArray,
									{
										success: function success(
											data,
											textStatus,
											jqXHR
										) {
											var myToast = Toastify({
												text: 'Your selections have been added to the cart.',
												duration: 6000,
												gravity: 'top',
												stopOnFocus: true,
												onClick: function onClick() {
													window.location.href =
														'/cart';
												},
											});
											myToast.showToast();
										},
										error: function error(
											jqXHR,
											textStatus,
											errorThrown
										) {
											var myToast = Toastify({
												duration: 10000,
												gravity: 'top',
												className: 'product-add-error',
												text: 'There was a problem adding this item to the cart. :(',
											});
											console.log(errorThrown);
											myToast.showToast();
										},
									}
								);
							}
						}
					}
				}
			}; // PDP

			this.pdp_set_select_facade = function (data, event) {
				var $select = $(event.target);
				var $flavor_button = $(event.target)
					.closest('li')
					.find('button');
				var $facade = $select.prev();
				var $selected_option = $select.find('option:selected');
				$select.data('product-id', $selected_option.data('product-id'));
				$facade
					.find('.thumb')
					.attr('src', $selected_option.data('image'));
				$facade.find('.title').html($selected_option.data('title'));
				$flavor_button.attr(
					'href',
					'#flavor-info-modal-' + $select.data('product-id')
				);
			}; // Search Page

			$('.search form img').on('click', function (event) {
				$('input[type="submit"]').trigger('click');
			}); // Cookies Profile Page

			this.cookie_featured_image = ko.observable('');

			this.cookie_swap_featured_image = function (data, event) {
				var val = $(event.target).attr('src');
				$(event.target).closest('li').siblings().removeClass('active');
				$(event.target).closest('li').addClass('active');
				self.cookie_featured_image(val);
			}; // Gifts by Occasion

			$('.occasion .select-wrapper select').on(
				'change',
				function (event) {
					window.location.href = event.target.value;
				}
			);
			$('.occasion .select-wrapper option').each(
				function (index, element) {
					if (window.location.href.includes(element.value)) {
						$(this).attr('selected', '');
					}
				}
			);

			// PDP Observables

			if (
				meta.page.pageType == 'product' &&
				meta.product.type != 'Cookies'
			) {
				this.pdp_option1_selected = ko.observable('');
				this.pdp_option2_selected = ko.observable('');
				this.pdp_option3_selected = ko.observable('');
				this.pdp_color_selected = ko.observable('');
				this.pdp_quantity_selected = ko.observable(1);
				this.pdp_product_data = ko.observable({});
				this.pdp_thumbs_array = ko.observableArray([]);
				this.pdp_thumbs_visible = ko.observableArray([]);
				this.pdp_variants_meta = ko.observableArray(
					meta.product.variants || []
				);
				this.pdp_active_possibilities = ko.observableArray([]);
				this.pdp_active_option = ko.observable(1);
				this.pdp_cookies = ko.observableArray([]);
				this.pdp_price = ko.observable(0);
				this.pdp_variant_prices = ko.observable();
				this.pdp_variant_compares = ko.observable(); // PDP Functions

				this.pdp_add_to_cart = function (product_title) {
					var $variety_array = $('.variety-select');
					var line_item_props = {};
					var variety_num = 1;
					line_item_props['contents'] = $('.contents-select').val();
					$variety_array.each(function (index, element) {
						line_item_props[index] = this.value;
					});
					console.log('added ' + line_item_props['contents']);
					CartJS.addItem(
						self.pdp_variant_selected_id(),
						self.pdp_quantity_selected(),
						line_item_props,
						{
							success: function success(data, textStatus, jqXHR) {
								var myToast = Toastify({
									text:
										product_title +
										' has been added to the cart.',
									duration: 6000,
									gravity: 'top',
									stopOnFocus: true,
									onClick: function onClick() {
										window.location.href = '/cart';
									},
								});
								myToast.showToast();
							},
							error: function error(
								jqXHR,
								textStatus,
								errorThrown
							) {
								var myToast = Toastify({
									duration: 10000,
									gravity: 'top',
									className: 'product-add-error',
									text: 'There was a problem adding this item to the cart. :(',
								});
								myToast.showToast();
							},
						}
					);
				};

				this.pdp_variant_selected_title = ko.computed(function () {
					var acc = '';

					if (this.pdp_option1_selected() != null) {
						acc = this.pdp_option1_selected();
					}

					if (this.pdp_option2_selected() != null) {
						acc = acc + ' / ' + this.pdp_option2_selected();
					}

					if (this.pdp_option3_selected() != null) {
						acc = acc + ' / ' + this.pdp_option3_selected();
					}

					return acc;
				}, this); // Reach out from each control input and make sure the
				// input's value is possible given the

				this.pdp_variant_selected_id = ko.computed(function () {
					var _this = this;

					if (this.pdp_variants_meta().length > 1) {
						var id = null;
						this.pdp_variants_meta().forEach(function (element) {
							if (
								element.public_title ==
								_this.pdp_variant_selected_title()
							) {
								id = element.id;
							}
						});
					} else if (this.pdp_variants_meta().length == 1) {
						id = this.pdp_variants_meta()[0].id;
					}

					if (id) {
						return id;
					}
				}, this);
				this.pdp_price = ko.computed(function () {
					if (
						this.pdp_variant_prices() != undefined &&
						this.pdp_variant_selected_id() != undefined
					) {
						return this.toDollars(
							this.pdp_variant_prices()[
								this.pdp_variant_selected_id()
							]
						);
					}
				}, this);
				this.pdp_compares = ko.computed(function () {
					if (
						this.pdp_variant_compares() != undefined &&
						this.pdp_variant_selected_id() != undefined
					) {
						return this.toDollars(
							this.pdp_variant_compares()[
								this.pdp_variant_selected_id()
							]
						);
					}
				}, this);

				this.pdp_increment = function (data, event) {
					event.preventDefault();
					self.pdp_quantity_selected(
						parseInt(self.pdp_quantity_selected() + 1)
					);
				};

				this.pdp_decrement = function (data, event) {
					event.preventDefault();

					if (self.pdp_quantity_selected() > 1) {
						self.pdp_quantity_selected(
							parseInt(self.pdp_quantity_selected() - 1)
						);
					}
				};
			} // Cart

			this.articles = ko.observableArray([]);
			this.item_count = ko.observable(CartJS.cart.item_count);
			this.total_price = ko.observable(CartJS.cart.total_price);
			this.items = ko.observableArray(CartJS.cart.items);
			this.variant_id = ko.observable(0);

			this.array_from_object = function (data, element) {
				console.log(Array.from(element));
				return Array.from(element);
			};

			this.clearCart = function () {
				CartJS.clear();
			};

			this.addItem = function (variantId, quantity) {
				var props =
					arguments.length > 2 && arguments[2] !== undefined
						? arguments[2]
						: {};
				var options =
					arguments.length > 3 && arguments[3] !== undefined
						? arguments[3]
						: {};
				CartJS.addItem(variantId, quantity, props, options);
			};

			this.removeItem = function (variantId) {
				CartJS.removeItemById(variantId);
			};

			this.increment = function (line_number, quantity) {
				quantity = parseInt(quantity + 1);
				CartJS.updateItem(
					line_number + 1,
					quantity,
					{},
					{
						success: function success(data, textStatus, jqXHR) {
							if (data.items[line_number].quantity < quantity) {
								console.log(
									'The requested quantity for this item is not available.'
								);
							}
						},
						error: function error(jqXHR, textStatus, errorThrown) {
							console.error('Error: ' + errorThrown + '!');
						},
					}
				);
			};

			this.decrement = function (line_number, quantity) {
				if (quantity > 1) {
					quantity = parseInt(quantity - 1);
					CartJS.updateItem(
						line_number + 1,
						quantity,
						{},
						{
							success: function success(data, textStatus, jqXHR) {
								if (
									data.items[line_number].quantity < quantity
								) {
									console.log(
										'The requested quantity for this item is not available.'
									);
								}
							},
							error: function error(
								jqXHR,
								textStatus,
								errorThrown
							) {
								console.error('Error: ' + errorThrown + '!');
							},
						}
					);
				}
			};

			this.removeItem = function (line_number) {
				CartJS.updateItem(
					line_number + 1,
					0,
					{},
					{
						success: function success(data, textStatus, jqXHR) {
							console.info('Item removed from cart.');
						},
						error: function error(jqXHR, textStatus, errorThrown) {
							console.error('Error: ' + errorThrown + '!');
						},
					}
				);
			};

			this.updatePrev = function (index, event) {
				event.preventDefault();
				var $input = $(event.target).prev().find('input');
				console.log($input);
				CartJS.updateItem(
					$input.data('index') + 1,
					$input.val(),
					{},
					{
						success: function success(data, textStatus, jqXHR) {},
						error: function error(jqXHR, textStatus, errorThrown) {
							console.error('Error: ' + errorThrown + '!');
						},
					}
				);
			};
		};

		ko.bindingHandlers.foreachprop = {
			transformObject: function transformObject(obj) {
				var properties = [];
				ko.utils.objectForEach(obj, function (key, value) {
					properties.push({
						key: key,
						value: value,
					});
				});
				return properties;
			},
			init: function init(
				element,
				valueAccessor,
				allBindingsAccessor,
				viewModel,
				bindingContext
			) {
				var properties = ko.pureComputed(function () {
					var obj = ko.utils.unwrapObservable(valueAccessor());
					return ko.bindingHandlers.foreachprop.transformObject(obj);
				});
				ko.applyBindingsToNode(
					element,
					{
						foreach: properties,
					},
					bindingContext
				);
				return {
					controlsDescendantBindings: true,
				};
			},
		};
		ko.applyBindings(new ViewModel()); // Everytime a request to CartJS is finished, sync the view model with CartJS.

		$(document).on('cart.requestComplete', function (event, cart) {
			ko.dataFor(document.body).items(CartJS.cart.items);
			ko.dataFor(document.body).total_price(CartJS.cart.total_price);
			ko.dataFor(document.body).item_count(CartJS.cart.item_count);
		}); // Sliders

		$('.home-hero .slides').slick({
			dots: true,
			arrows: false,
			infinite: true,
			autoplay: true,
			autoplaySpeed: 4000,
		});
		$('.sweet-gift .slides').slick({
			arrows: true,
			dots: false,
			infinite: true,
			slidesToShow: 3,
			slidesToScroll: 1,
			prevArrow:
				"<img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/0358/0061/3001/files/sweet-arrow-left.png?v=1584571093'>",
			nextArrow:
				"<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/0358/0061/3001/files/sweet-arrow-right.png?v=1584571093'>",
			responsive: [
				{
					breakpoint: 1325,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
						infinite: true,
					},
				},
				{
					breakpoint: 820,
					settings: {
						arrows: false,
						dots: true,
						slidesToShow: 1,
						slidesToScroll: 1,
					},
				},
			],
		});
		$('.home-testimonials .slides').slick({
			arrows: false,
			dots: true,
		}); //Mega Menu
		//Add a class to the parent trigger to keep the menu open for 1s when user navigates out of hitbox.

		$('.header .top-level li:first-of-type').on('mouseleave', function () {
			$('.header .top-level li:first-of-type').addClass('keep-me-open');
			setTimeout(function () {
				$('.header .top-level li:first-of-type').removeClass(
					'keep-me-open'
				);
			}, 500);
		}); // //Keep active effect over parent trigger while cursor is within mega menu
		// $('.header-mega-menu').on('mouseover', function() {
		//   $('.header .top-level li:first-of-type').addClass('active');
		// })
		// $('.header-mega-menu').on('mouseout', function() {
		//   $('.header .top-level li:first-of-type').removeClass('active');
		// })
		//Mobile Menu

		$('.header .mobile-menu-icon-wrapper').on('click', function () {
			$('body').toggleClass('mobile-menu-showing');
			var vh = window.innerHeight * 0.01; // Then we set the value in the --vh custom property to the root of the document

			document.documentElement.style.setProperty(
				'--vh',
				''.concat(vh, 'px')
			);
		});
		$('.level-1-list li.has-sublist').on('click', function (event) {
			$(event.target).next().slideToggle();
			$(event.target).next().toggleClass('open');
			$(event.target).toggleClass('open');
		}); // Cookie PDP

		$('.cookie-profile .accordion-trigger').on('click', function (event) {
			$(event.target).toggleClass('open');
			$('.cookie-profile .accordion').slideToggle();
		}); // About Page

		$('.milestone-slider').slick({
			slidesToShow: 1,
			arrows: false,
			dots: false,
			asNavFor: '.milestone-nav-mobile',
		});
		$('.milestone-nav li').each(function (index) {
			$(this).on('click', function (event) {
				$(event.currentTarget).siblings().removeClass('active');
				$(event.currentTarget).addClass('active');

				switch (index) {
					case 0:
						var gradient_perc = 7.6;
						break;

					case 1:
						var gradient_perc = 21.2;
						break;

					case 2:
						var gradient_perc = 35.6;
						break;

					case 3:
						var gradient_perc = 50;
						break;

					case 4:
						var gradient_perc = 64.7;
						break;

					case 5:
						var gradient_perc = 78.8;
						break;

					case 6:
						var gradient_perc = 93.3;
						break;

					case 7:
						var gradient_perc = 100;
						break;

					default: // code block
				}

				$('.progress-bar').css({
					background:
						'linear-gradient(to right, rgba(216,216,216, 1) 0%, rgba(216,216,216, 1) ' +
						gradient_perc +
						'%, rgba(216,216,216, .5) ' +
						gradient_perc +
						'%, rgba(216,216,216, .5) 100%',
				});
				$(event.currentTarget)
					.closest('ol')
					.attr('data-progress', (index + 1) * 1.25 * 10);
				$('.milestone-slider').slick('slickGoTo', index);
			});
		});
		$('.milestone-nav-mobile').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: true,
			arrows: false,
			asNavFor: '.milestone-slider',
		}); // FAQ page

		$('.category > h2').each(function (index, element) {
			$(this).on('click', function (event) {
				$(event.target).closest('.category').toggleClass('open');
				$(event.target).next().slideToggle();
			});
		});

		function resetVariant(element, name) {
			element.find('option[value="' + name + '"]').prop('selected', true);
			element.change();
		}

		var index = 0;
		$('.variety-select').each(function () {
			var thisThing = $(this);
			index += 1;
			switch (index) {
				case 1:
					resetVariant(thisThing, 'Chocolate Chip');
					break;
				case 2:
					resetVariant(thisThing, 'Oatmeal Raisin');
					break;
				case 3:
					resetVariant(thisThing, 'Snickerdoodle');
					break;
				case 4:
					resetVariant(thisThing, 'Dr. Midnight');
					break;
				case 5:
					resetVariant(thisThing, 'Lemon Drop');
					break;
				case 6:
					resetVariant(thisThing, 'Mint Condition');
					break;
				case 7:
					resetVariant(thisThing, 'Almond Joe');
					break;
				case 8:
					resetVariant(thisThing, 'Peanut Butter');
					break;
				case 9:
					resetVariant(thisThing, 'Cahootz');
					break;
				case 10:
					resetVariant(thisThing, 'Chocolate Chip w/ Walnuts');
					break;
				case 11:
					resetVariant(thisThing, 'Ginger Spice');
					break;
				default:
					console.log('none');
			}
		});

		/******************************************
    Header Search
  ******************************************/

		// Show desktop search on click and focus on input
		$('.icon--search').on('click', function (e) {
			e.preventDefault();

			$('.desktop-search').fadeIn('fast', '', function () {
				$('body').addClass('search-open');
				$('.desktop-search input').focus();
			});
		});

		// Close desktop search if click outside
		$('body').on('click', function (e) {
			var desktopSearch = $('.desktop-search');

			if (
				!desktopSearch.is(e.target) &&
				desktopSearch.has(e.target).length === 0 &&
				$('body').hasClass('search-open')
			) {
				desktopSearch.fadeOut('fast', '', function () {
					$('body').removeClass('search-open');
					$('.icon--search').focus();
					$('#boost-sd__search-widget-init-wrapper').addClass(
						'boost-sd__g-hide'
					);
				});
			}
		});
	});
})(jQuery);
//Sleepify Starter Theme by Sleepless Media
//This file is intended to be used for small ongoing fixes or changes post-launch.
